// ©2024 Austin App House. All rights reserved.
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { toggleModal } from '../../storage/actions/modalsActions';
import getTeams from '../../utils/api/get/getTeams';
import deleteTeam from '../../utils/api/delete/deleteTeam';
import { reloadData } from '../../storage/actions/applicationStateActions';
import Notification from '../../components/notification';
import DashboardIcon from '../../components/dashboard/icons/DashboardIcon';
import RowActions from '../../components/dashboard/RowActions';

const ManageFields = ({ mainContainer, toggleModal, isReload, reloadData }) => {
  const [teams, setTeams] = useState([]);

  useEffect(() => {
    fetchTeams();
  }, [isReload]);

  const fetchTeams = async () => {
    toggleModal(true, 'loader');
    const data = await getTeams();
    setTeams(data);
    toggleModal(false, 'loader');
  };

  const openEditTeamModal = (teamId) => {
    toggleModal(true, 'addOrEditTeams', false, { id: teamId });
  };

  const openAddTeamModal = () => {
    toggleModal(true, 'addOrEditTeams');
  };

  const copyTeamId = async (teamId) => {
    try {
      await navigator.clipboard.writeText(teamId);
      Notification('success', { message: 'Team ID copied to clipboard!' });
    } catch (error) {
      console.error('Unable to copy item to clipboard:', error);
    }
  };

  const onDeleteTeam = (teamId, name) => {
    toggleModal(true, 'confirmModal', true, {
      onAccept() {
        deleteTeam(teamId).then(() => reloadData(teamId));
      },
      header: `Delete ${name || 'team'}?`,
      buttonLabels: {
        reject: 'Cancel',
        confirm: 'Delete',
      },
    });
  };

  return (
    <div className="subpage-wrap">
      <div className="subpage-header">
        <h1 className="subpage-title">Manage Teams</h1>
        <button className="subpage-btn subpage-btn--gold" type="button" onClick={openAddTeamModal}>
          <DashboardIcon name="plus" size={18} strokeWidth="2.5" />
          Add Team
        </button>
      </div>

      <div className="subpage-table-scroll">
        <table className="subpage-table">
          <thead>
            <tr>
              <th>Team name</th>
              <th>Members</th>
              <th style={{ textAlign: 'right' }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {teams.map(({ name, _id, teamUsersCount }) => (
              <tr key={_id}>
                <td>
                  <span
                    className="row-name cursor_pointer"
                    role="button"
                    tabIndex={0}
                    onClick={() => openEditTeamModal(_id, name)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') openEditTeamModal(_id, name);
                    }}
                  >
                    {name}
                  </span>
                </td>
                <td>{teamUsersCount}</td>
                <td>
                  <RowActions
                    alignEnd
                    showDuplicate
                    onEdit={(e) => {
                      e.preventDefault();
                      openEditTeamModal(_id);
                    }}
                    onDelete={(e) => {
                      e.preventDefault();
                      onDeleteTeam(_id, name);
                    }}
                    onDuplicate={(e) => {
                      e.preventDefault();
                      copyTeamId(_id);
                    }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const mapDispatchToProps = { toggleModal, reloadData };
const mapStateToProps = (state) => ({
  modalState: state.modalState.addOrEditTeams,
  isReload: state.applicationState.isReload,
});

export default connect(mapStateToProps, mapDispatchToProps)(ManageFields);
